/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {openPaymentPopup} from '../../common/paymentPopup/actions';
import {openMenu} from '../../common/menu/actions';
import {openTables} from '../../common/tables/actions';

class Controls extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        openPaymentPopup: React.PropTypes.func,
        openMenu: React.PropTypes.func,
        openTables: React.PropTypes.func,
        homepage: React.PropTypes.object.isRequired,
        selectedProducts: React.PropTypes.object,
        payingInProgress: React.PropTypes.bool,
        onlineState: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.doOpenPaymentPopup = this.doOpenPaymentPopup.bind(this);
        this.canDoOrder = this.canDoOrder.bind(this);
        this.canOpenPopup = this.canOpenPopup.bind(this);
        this.openMenu = this.openMenu.bind(this);
    }

    openMenu() {
        const {openMenu} = this.props;
        openMenu();
    }

    doOpenPaymentPopup() {
        const {openPaymentPopup} = this.props;
        if (this.canOpenPopup()) {
            openPaymentPopup();
        }
    }

    canOpenPopup() {
        const {selectedProducts: items} = this.props;
        return items.size > 0
    }

    canDoOrder() {
        const {payingInProgress, selectedProducts: items} = this.props;
        return items.size > 0 && !payingInProgress;
    }

    render() {
        const {homepage, openTables, onlineState, msg} = this.props;

        return (
            <section id="controls" className="controlPanel">
              <div className="controlPanel-box">
                <div className="boxBtn color-greenLight text-l" onClick={() => this.openMenu()}>
                    <div className="boxBtn-inner">
                      <svg className={`shape shape-bars`}>
                        <use xlinkHref={`#shape-bars`}></use>
                      </svg>
                    </div>
                </div>
              </div>
              <div className="controlPanel-box">
                <div className="boxBtn color-green text-l text-up" onClick={() => openTables()}>
                    <div className="boxBtn-inner controls-table">
                        {msg.homepage.controls.table}
                    </div>
                </div>
              </div>
              <div className="controlPanel-box view-big">
                <div className={`boxBtn color-red text-xl text-up ${this.canOpenPopup() ? '' : 'disabled'}`}
                     onClick={() => this.doOpenPaymentPopup()}>
                    <div className="boxBtn-inner">
                        {msg.homepage.controls.issue}
                    </div>
                </div>
              </div>
              <div className="controlPanel-box view-big">
                <div className={`boxBtn color-red text-l text-up ${this.canDoOrder() ? '' : 'disabled'}`}
                     onClick={() => homepage.doOrder(false, false)}>
                    <div className="boxBtn-inner">
                        {msg.homepage.controls.quickSale}
                        {!onlineState &&
                        <span>{msg.global.offline}</span>
                        }
                    </div>
                </div>
              </div>
            </section>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    selectedProducts: state.categories.get('selectedProducts'),
    payingInProgress: state.categories.get('payingInProgress'),
    onlineState: state.categories.get('onlineState')
}), {openPaymentPopup, openMenu, openTables})(Controls);



// WEBPACK FOOTER //
// ./src/browser/home/Controls.js